import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormLabel } from "@/components/ui/form";
import { X } from "lucide-react";
import type { CemeteryFormData } from "../types";

interface InlineCemeteryFormProps {
  formData: CemeteryFormData;
  onChange: (data: CemeteryFormData) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export function InlineCemeteryForm({
  formData,
  onChange,
  onSubmit,
  onCancel,
  isSubmitting,
}: InlineCemeteryFormProps) {
  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/50">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold">Luo uusi hautausmaa</h3>
        <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
          <X className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-4">
        <div>
          <FormLabel>Hautausmaan nimi *</FormLabel>
          <Input
            value={formData.name}
            onChange={(e) => onChange({ ...formData, name: e.target.value })}
          />
        </div>

        <div>
          <FormLabel>Osoite *</FormLabel>
          <Input
            value={formData.address}
            onChange={(e) => onChange({ ...formData, address: e.target.value })}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <FormLabel>Postinumero *</FormLabel>
            <Input
              value={formData.postal_code}
              onChange={(e) => onChange({ ...formData, postal_code: e.target.value })}
            />
          </div>
          <div>
            <FormLabel>Kaupunki *</FormLabel>
            <Input
              value={formData.city}
              onChange={(e) => onChange({ ...formData, city: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Peruuta
        </Button>
        <Button type="button" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Luodaan..." : "Tallenna hautausmaa"}
        </Button>
      </div>
    </div>
  );
}
